import $ from 'jquery';
import 'chosen-js';
import 'jquery-ui/ui/widgets/datepicker';
import moment from 'moment';
import calcularDigitoVerificacion from './digito_de_verificacion';
import 'bootstrap/js/src/modal';

/* Slugify function */
function slugify (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}
/* fin slugify */

window.moment = moment

moment.locale("es")

$( document ).on('turbolinks:load', function() {
  $.datepicker.setDefaults(
    $.extend(
      { dateFormat: 'yy-mm-dd' },
      $.datepicker.regional.es
    )
  )

  $('.chzn-select').chosen({ no_results_text: 'No se encontraron resultados para' })

  $('.fecha-datepicker').datepicker({
    endDate: new Date(),
    changeMonth: true,
    changeYear: true
  })

  $(document).on('click', '#exportar', function () {
    if (/xlsx/.test($('form').attr('action'))) {
      $('form').attr('action', $('form').attr('action').replace('.xlsx', '.csv'))
    } else if (!/csv/.test($('form').attr('action'))) {
      $('form').attr('action', $('form').attr('action') + '.csv')
    }
  })

  $(document).on('click', '#filtrar', function () {
    if (/csv/.test($('form').attr('action'))) {
      $('form').attr('action', $('form').attr('action').replace('.csv', ''))
    } else if (/xlsx/.test($('form').attr('action'))) {
      $('form').attr('action', $('form').attr('action').replace('.xlsx', ''))
    }
  })

  $(document).on('click', '#exportar_excel', function () {
    if (/csv/.test($('form').attr('action'))) {
      $('form').attr('action', $('form').attr('action').replace('.csv', '.xlsx'))
    } else if (!/xlsx/.test($('#formulario_exportar').attr('action'))) {
      $('#formulario_exportar').attr('action', $('#formulario_exportar').attr('action') + '.xlsx')
    }
  })

  $(document).on('click', '#ver-historial-de-cambios', function (e) {
    e.preventDefault()
    var historial = JSON.parse($(this).attr('data-historial'))
    var tbody = $('#historial-tbody')

    // To do: mostrar el historial
    for (var i = 0; i < historial.length; i++) {
      var value = historial[i]
      var fecha = value.timestamp * 1000
      var cambios = value.changes
      var primero = true
      var cantidad = 0
      for (var atributo in cambios) {
        var antes = cambios[atributo][0]
        var despues = cambios[atributo][1]
        if (antes || despues) {
          if (!antes) {
            antes = '|--nada--|'
          }
          if (!despues) {
            despues = '|--nada--|'
          }
          var tr = $('<tr></tr>')
          if (primero) {
            primero = false
            var tdcuando = $('<td>' + moment(fecha).fromNow() + '</td>')
            tr.append(tdcuando)
          }
          var td = $('<td>' + atributo + '</td>')
          tr.append(td)
          td = $('<td>' + antes + '</td>')
          tr.append(td)
          td = $('<td>' + despues + '</td>')
          tr.append(td)
          tbody.append(tr)
          cantidad++
        }
      }
      tdcuando.attr('rowspan', cantidad)
    }
    //

    $('#historial-container').removeClass('d-none')
    $(this).addClass('d-none')
  })

  // Esconder el formulario
  $(document).on('click', '.escondedero', function () {
    var $this = $(this)
    $('#' + $this.attr('data-target')).toggleClass('d-none')
  })

  $('.convert-time-ago').each(function (item) {
    var $item = $(this)
    var fecha = new Date($item.attr('data-date') * 1000)
    $item.text(moment(fecha).fromNow())
  })

  // Etiquetas y anotaciones
  if ($('.hidden-anotaciones').length > 0) {
    var anotaciones = []
    try {
      anotaciones = JSON.parse($('.hidden-anotaciones').val() || '[]')
      for (var anotacion in anotaciones) {
        $('#contenedor-anotaciones').append('<span id="anotacion-' + anotaciones[anotacion] + '" class="badge badge-info margin-badge"><i class="fa borrar-anotacion fa-times-circle" data-id="' + anotaciones[anotacion] + '"></i> ' + anotaciones[anotacion] + '</span>')
      }
    } catch (e) {
      anotaciones = []
    }

    $(document).on('click', '.borrar-anotacion', function () {
      var anotacion = $(this).attr('data-id')
      var index = anotaciones.indexOf(anotacion)
      $(this).parent().remove()
      if (index > -1) {
        anotaciones.splice(index, 1)
      }
      $('.hidden-anotaciones').val(JSON.stringify(anotaciones))
    })

    $(document).on('click', '#agregar_anotacion', function () {
      var anotacion = $('#anotacion').val()
      if (anotacion) {
        $('#contenedor-anotaciones').append('<span id="anotacion-' + anotacion + '" class="badge badge-info margin-badge"><i class="fa borrar-anotacion fa-times-circle" data-id="' + anotacion + '"></i> ' + anotacion + '</span>')
        anotaciones.push(anotacion)
        $('.hidden-anotaciones').val(JSON.stringify(anotaciones))
        $('#anotacion').val('')
      }
    })
  }

  if ($('.hidden-etiquetas').length > 0) {
    var etiquetas = []
    try {
      etiquetas = JSON.parse($('.hidden-etiquetas').val() || '[]')
      for (var etiqueta in etiquetas) {
        $('#contenedor-etiquetas').append('<span id="etiqueta-' + etiquetas[etiqueta] + '" class="badge badge-info margin-badge"><i class="fa borrar-etiqueta fa-times-circle" data-id="' + etiquetas[etiqueta] + '"></i> ' + etiquetas[etiqueta] + '</span>')
      }
    } catch (e) {
      etiquetas = []
    }

    $(document).on('click', '.borrar-etiqueta', function () {
      var etiqueta = $(this).attr('data-id')
      var index = etiquetas.indexOf(etiqueta)
      $(this).parent().remove()
      if (index > -1) {
        etiquetas.splice(index, 1)
      }
      $('.hidden-etiquetas').val(JSON.stringify(etiquetas))
    })

    $(document).on('click', '#agregar_etiqueta', function () {
      var etiqueta = $('#etiqueta').val()
      if (etiqueta) {
        $('#contenedor-etiquetas').append('<span id="etiqueta-' + etiqueta + '" class="badge badge-info margin-badge"><i class="fa borrar-etiqueta fa-times-circle" data-id="' + etiqueta + '"></i> ' + etiqueta + '</span>')
        etiquetas.push(etiqueta)
        $('.hidden-etiquetas').val(JSON.stringify(etiquetas))
        $('#etiqueta').val('')
      }
    })
  }
  /* fin anotaciones y etiquetas */

  /* personas */
  $(document).on('change', '#persona_identificacion', function () {
    var identificacion = $(this).val()
    $('#persona_digito_verificacion').val(calcularDigitoVerificacion(identificacion))
  })
  /* fin personas */

  /* administracion */
  $('.toggle-group').click(function () {
    var $el = $('.group-' + $(this).attr('data-group'))
    var $caret = $('#caret-' + $(this).attr('data-group'))
    $el.toggleClass('d-none')
    $caret.toggleClass('fa-caret-right').toggleClass('fa-caret-down')
  })
  /* fin administracion */

  /* Formulario de CDAs */
  $(document).on('keyup', "#cda_nombre", function(){
    $('#cda_slug').val(slugify($("#cda_nombre").val()))
  })
});